module.exports = __webpack_public_path__ + "img/xit (4).e866fceb.jpg";